export class KamListFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/kam-list-filter.ts